import { get } from 'lodash-es'

export function env(key: string) {
  return get(window.env, key, import.meta.env[key])
}
